export default __webpack_public_path__ + "static/media/amax-footer.e1f41984.svg";